// extracted by mini-css-extract-plugin
export default {"tip_content":"RewardsExplained_tip_content__fxp3b","desc":"RewardsExplained_desc__zyxnA","t1":"RewardsExplained_t1__8DCz1","m":"RewardsExplained_m__XPyEi"};